import React from "react";
import cx from "classnames";

function DialogBody(props) {
  const { children, baseClassName, className, style } = props;

  return (
    <div className={cx(baseClassName, className)} style={style}>
      {children}
    </div>
  );
}

DialogBody.defaultProps = {
  baseClassName: "si-c-dialog__body",
};

export default DialogBody;
